
export const nulToEmptyAndTrim = (value)=>{
    if(!value) return "";
    return value.trim();
}

export const toStringIfNotNull = (value)=>{
    if(!value) return null;
    return value.toString();
}